export default __webpack_public_path__ + "static/media/brand_desktop.e561c764.png";